export default "__VITE_ASSET__B64UG04C__"